import { setContext } from '@apollo/client/link/context';
import { tournamentEngine } from 'tods-competition-factory';

import { type ClubSparkAuthenticationInterface } from 'typedefs/authTypes';

export const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const authUser = JSON.parse(localStorage.getItem('authenticatedUser')) as ClubSparkAuthenticationInterface;
  const token = authUser?.metadata?.token;
  const version = tournamentEngine.version();

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      'tengine-ver': version,
      Authorization: token ? token : '',
    },
    fetch,
  };
});

export const rankingAuthLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const authUser = JSON.parse(localStorage.getItem('authenticatedUser')) as ClubSparkAuthenticationInterface;
  const token = authUser?.metadata?.token;

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Authorization: token ? token : '',
    },
    fetch,
  };
});
